/* merchant/reducer */
import { createReducer } from "typesafe-actions";
import { MerchantStagingActionTypes, MerchantStagingState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchAllSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
  updateState,
} from "./actions";

export const initialState: MerchantStagingState = {
  data: undefined,
  dataAll: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchAllSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>
  | ReturnType<typeof updateState>;

export default createReducer<MerchantStagingState, ActionType>(initialState)
  .handleType(MerchantStagingActionTypes.FETCH, (state) => {
    console.log("hit")
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(MerchantStagingActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantStagingActionTypes.FETCHALL_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      dataAll: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantStagingActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(MerchantStagingActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(MerchantStagingActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantStagingActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  })
  .handleType(MerchantStagingActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(MerchantStagingActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(MerchantStagingActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  })
  .handleType(MerchantStagingActionTypes.UPDATE_STATE, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
      data: {
        errors: undefined,
        data: action.payload,
        dataAll: undefined,
        meta: {
          totalObjects: action.payload.length,
        },
      },
    };
  });
